import { render } from "./AdminCommonSetting.vue?vue&type=template&id=1da2f130&scoped=true"
import script from "./AdminCommonSetting.vue?vue&type=script&lang=js"
export * from "./AdminCommonSetting.vue?vue&type=script&lang=js"

import "./AdminCommonSetting.vue?vue&type=style&index=0&id=1da2f130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da2f130"]])

export default __exports__